import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { SxProps, Theme } from '@mui/material/styles'

interface ContentBlockProps {
  heading?: string
  children: React.ReactNode
  sx?: SxProps<Theme>
}

export default function ContentBlock({ heading, children, sx }: ContentBlockProps) {
  return (
    <Box sx={{ mb: 4, ...sx }}>
      {heading && (
        <Typography
          variant="h5"
          sx={{ mb: 1.5, color: 'primary.main', fontWeight: 600 }}
        >
          {heading}
        </Typography>
      )}
      {children}
    </Box>
  )
}
